import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const ProductManagementTabs = () => {
  const location = useLocation();
  
  const isSubCategoriesActive = location.pathname.includes("/subcategories");
  const isPreSubCategoriesActive = location.pathname.includes("/presubcategories");
  const isAttributesActive = location.pathname.includes("/attributes");

  const [hoveredTab, setHoveredTab] = useState(null);

  const containerStyle = {
    borderBottom: "1px solid #e9ecef"
  };

  const navStyle = {
    borderBottom: "none"
  };

  const getLinkStyle = (isActive, tabId) => ({
    color: isActive ? "#403fad" : (hoveredTab === tabId ? "#495057" : "#6c757d"),
    border: "none",
    borderBottom: `3px solid ${isActive ? "#403fad" : (hoveredTab === tabId ? "#dee2e6" : "transparent")}`,
    padding: "12px 20px",
    fontWeight: "500",
    transition: "all 0.3s ease",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    backgroundColor: "transparent"
  });

  return (
    <div className="nav_tab_container mb-3" style={containerStyle}>
      <div className="nav nav-tabs" id="navTab" role="tablist" style={navStyle}>
        <Link
          to="/admin/productManagement/subcategories/list/1"
          className={`nav-link ${isSubCategoriesActive ? "active" : ""}`}
          role="tab"
          style={getLinkStyle(isSubCategoriesActive, "subcategories")}
          onMouseEnter={() => setHoveredTab("subcategories")}
          onMouseLeave={() => setHoveredTab(null)}
        >
          Sub Categories
        </Link>
        <Link
          to="/admin/productManagement/presubcategories/list/1"
          className={`nav-link ${isPreSubCategoriesActive ? "active" : ""}`}
          role="tab"
          style={getLinkStyle(isPreSubCategoriesActive, "presubcategories")}
          onMouseEnter={() => setHoveredTab("presubcategories")}
          onMouseLeave={() => setHoveredTab(null)}
        >
          Pre-Sub Categories
        </Link>
        <Link
          to="/admin/productManagement/attributes/list/1"
          className={`nav-link ${isAttributesActive ? "active" : ""}`}
          role="tab"
          style={getLinkStyle(isAttributesActive, "attributes")}
          onMouseEnter={() => setHoveredTab("attributes")}
          onMouseLeave={() => setHoveredTab(null)}
        >
          Attributes
        </Link>
      </div>
    </div>
  );
};

export default ProductManagementTabs;
